import {
  useCustomerResponse,
  useOptionalUser,
  useSessionId,
  useUser,
} from '@aboutyou/user';
import {TrackingCustomerData} from '@aboutyou/legacy-tracking-sdk';
import {getTrackingCustomer} from '../../utils/getTrackingCustomer';

export const useConvertUserAndSessionToCustomer =
  (): TrackingCustomerData | null => {
    const sessionState = useSessionId();
    const {data: optionalUserData} = useOptionalUser();
    const customerResponse = useCustomerResponse();
    const {data: userData} = useUser();

    if (
      !sessionState.data ||
      !optionalUserData ||
      customerResponse.isLoading ||
      customerResponse.error
    ) {
      return null;
    }
    const isLoggedIn = !!(userData && 'token' in userData && userData.token);
    const user = optionalUserData;
    const customer = customerResponse.data;
    const returnObject = getTrackingCustomer({user, customer, isLoggedIn});

    return returnObject;
  };
